import React, { useState } from 'react';
import { getWork, setDeleteWorkMulti, deleteWorkMulti } from '../../api/work'
import { typework } from '../../api/list'
import PageList from '../../components/PageListAPI'
import Button from '@mui/material/Button'
import { useCan } from '../../hooks/useCan';
import { SLUGS } from '../../enum/permissions.enum';
import { fetchDispath } from '../../functions/fetch'
import { useDispatch } from 'react-redux';
import { enqueueSnackbar } from 'src/reducers/notifier';


export default function WorkListBasket(props) {
  const can = useCan()
  const idProject = props.match.params.idProject
  const [reload, setReload] = useState(false)
  const columns = [
    { id: 'number', name: 'Номер', },
    { id: 'name', name: 'Наименование', },
    { id: 'storageUnit', name: 'Ед. изм.', },
    { id: 'count', name: 'Количество', },
    { id: 'balance', name: 'Выполнено', },
    { id: 'done', name: 'Осталось', },
    { id: 'typeW', name: 'Тип', },
    { id: 'price', name: 'Стоимость единицы', },
    {
      id: 'restore', name: 'Восстановить', align: 'left', type: 'component',
      component: ({ obj }) => <Restore obj={obj} idProject={idProject} reload={() => setReload(true)} />
    },
  ]
  return (
    <div className='App-paper'>
      <PageList
        name='workList'
        title='Корзина работ'
        columns={columns}
        createItem={false}
        deleteItem={can(SLUGS.PROJECT.WORK.MANAGE)}
        loadAPI={{
          param: {
            id: props.match.params.idProject
          },
          querty: {
            isdeleted: 1
          },
          transform: (res => {
            return {
              count: res.count,
              get: res.get.map(obj => {
                return { ...obj, done: Math.round((obj.count - obj.balance) * 1000) / 1000 }
              })
            }
          }),
          request: getWork,
        }}
        deleteAPI={deleteWorkMulti(props.match.params.idProject)}
        disabledDelete={obj => obj.balance > 0}
        click={false}
        filterProps={[
          {
            type: 'find_text',
            field: 'find',
            name: 'Поиск по наименованию'
          },
          {
            type: 'autocomplite',
            path: typework.getList.path,
            field: 'idType',
            name: 'Тип работ',
          },
        ]}
        deleteMulti
        deleteMultiProps='arr'
        reload={reload}
        reloadFunc={() => setReload(false)}
        {...props}
      />
    </div>
  )
}

function Restore({ obj, idProject, reload }) {
  const dispath = useDispatch()
  const deleteCustom = () => {
    dispath(fetchDispath({
      body: {
        arr: [obj.id]
      },
      progress: false,
      request: setDeleteWorkMulti(idProject)
    }))
      .then((res) => {
        if (res) {
          reload()
          dispath(enqueueSnackbar({
            message: `success`,
            options: { variant: 'success' }
          }))
        }
      })
  }
  return <div><Button onClick={deleteCustom}>Восстановить</Button></div>
}